"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapCategoryBarFromPageNavigation = void 0;
const mapCategoryBarFromPageNavigation = (categoryBarData)=>{
    var _categoryBarData_items;
    const items = (_categoryBarData_items = categoryBarData === null || categoryBarData === void 0 ? void 0 : categoryBarData.items) !== null && _categoryBarData_items !== void 0 ? _categoryBarData_items : [];
    return items.map((item)=>{
        var _item_itemId, _item_label, _item_url;
        return {
            id: (_item_itemId = item === null || item === void 0 ? void 0 : item.itemId) !== null && _item_itemId !== void 0 ? _item_itemId : '',
            title: (_item_label = item === null || item === void 0 ? void 0 : item.label) !== null && _item_label !== void 0 ? _item_label : '',
            relativeUrl: (_item_url = item === null || item === void 0 ? void 0 : item.url) !== null && _item_url !== void 0 ? _item_url : ''
        };
    });
};
exports.mapCategoryBarFromPageNavigation = mapCategoryBarFromPageNavigation;
